<template>
  <div class="fitting center laya-swim-fitting">
    <template v-if="category !== ''">
      <collapsible
        v-if="questions_to_include[category].includes('age')"
        :step="questions_to_include[category].indexOf('age') + 1"
        :label="`Age: <b>${age}</b>`"
        :has_next="questions_to_include[category].indexOf('age') + 1 < questions_to_include[category].length"
        :max_height="1080"
      >
        <step_age />
      </collapsible>

      <collapsible
        v-if="questions_to_include[category].includes('height')"
        :step="questions_to_include[category].indexOf('height') + 1"
        :label="`Height: <b>${height}</b>`"
        :has_next="questions_to_include[category].indexOf('height') + 1 < questions_to_include[category].length"
        :max_height="1080"
      >
        <step_height />
      </collapsible>

      <collapsible
        v-if="questions_to_include[category].includes('weight')"
        :step="questions_to_include[category].indexOf('weight') + 1"
        :label="`Weight: <b>${weight}</b>`"
        :has_next="questions_to_include[category].indexOf('weight') + 1 < questions_to_include[category].length"
        :max_height="1080"
      >
        <step_weight />
      </collapsible>

      <collapsible
        v-if="questions_to_include[category].includes('band')"
        :step="questions_to_include[category].indexOf('band') + 1"
        :label="`Band size: <b>${underbust_size}&quot;</b>`"
        :has_next="questions_to_include[category].indexOf('band') + 1 < questions_to_include[category].length"
        :max_height="1080"
      >
        <step_1></step_1>
      </collapsible>

      <collapsible
        v-if="questions_to_include[category].includes('cup')"
        :step="questions_to_include[category].indexOf('cup') + 1"
        :label="`Cup size: <b>${cup_size}&quot;</b>`"
        :has_next="questions_to_include[category].indexOf('cup') + 1 < questions_to_include[category].length"
        :max_height="1080"
      >
        <step_2></step_2>
      </collapsible>

      <collapsible
        v-if="questions_to_include[category].includes('shape')"
        :step="questions_to_include[category].indexOf('shape') + 1"
        :label="`Shape: <b>${shapeToDisplayName(shape)}</b>`"
        :max_height="2500"
      >
        <step_3></step_3>
      </collapsible>

      <collapsible
        v-if="questions_to_include[category].includes('waist_hips')"
        :step="questions_to_include[category].indexOf('waist_hips') + 1"
        :label="`Waist: <b>${waist_size}&quot;</b> Hip: <b>${hip_size}&quot;</b>`"
        :has_next="questions_to_include[category].indexOf('waist_hips') + 1 < questions_to_include[category].length"
        :max_height="3000"
      >
        <step_4></step_4>
      </collapsible>

      <collapsible
        v-if="questions_to_include[category].includes('results')"
        :step="questions_to_include[category].indexOf('results') + 1"
        :has_next="questions_to_include[category].indexOf('results') + 1 < questions_to_include[category].length"
        :max-height="9999"
      >
        <step_5 :online_fitting="online_fitting" />
        <results v-if="fittings" />
      </collapsible>
    </template>
  </div>
</template>

<script>
  import host from './host';
  import shopify from './mixins/shopify';

  import collapsible from './components/collapsible.vue';
  import step_1 from "./components/step_1.vue";
  import step_2 from "./components/step_2.vue";
  import step_3 from "./components/step_3.vue";
  import step_4 from "./components/step_4.vue";
  import step_5 from "./components/step_5.vue";
  import step_age from "./components/step_age.vue";
  import step_weight from "./components/step_weight.vue";
  import step_height from "./components/step_height.vue";
  import responsive_youtube from "./components/responsive_youtube.vue";
  import results from "./components/results.vue";

  function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }

  export default {
    mixins: [
      shopify,
    ],
    components: {
      collapsible,
      step_1,
      step_2,
      step_3,
      step_4,
      step_5,
      step_age,
      step_weight,
      step_height,
      responsive_youtube,
      results,
    },
    data(){
      return {
        step: window.localStorage.getItem('step') || 1,

        age: window.localStorage.getItem('age') || null,
        weight: window.localStorage.getItem('weight') || null,
        height: window.localStorage.getItem('height') || null,

        underbust_size: window.localStorage.getItem('underbust_size') || null,
        cup_size: window.localStorage.getItem('cup_size') || null,
        shape: window.localStorage.getItem('shape') || null,
        type: window.localStorage.getItem('type') || 'Activewear',
        fit: window.localStorage.getItem('fit') || 'normal',

        waist_size: window.localStorage.getItem('waist_size') || null,
        hip_size: window.localStorage.getItem('hip_size') || null,
        skipped_bottoms: (window.localStorage.getItem('skipped_bottoms') === 'true') || null,

        sizes: ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'],

        online_fitting_id: window.localStorage.getItem('online_fitting_id') || null,
        online_fitting: null,
        fittings: [],

        use_centimeters: window.localStorage.getItem('use_centimeters') === 'true' || false,

        category: window.localStorage.getItem('category') || 'women',
        categories: {
          'women': 'Women',
        },

        division_types: {
          'women': ['ACTIVEWEAR', 'CASUAL TOPS & JACKETS', 'SWIMWEAR', 'LOUNGEWEAR', 'SHORTS', 'PANTS & TROUSERS', 'SKIRTS', 'BODY & JUMPSUITS', 'DRESSES'],
        },

        questions_to_include: {
          'women': ['band', 'cup', 'shape', 'waist_hips', 'results'],
        },
      };
    },
    watch: {
      step: function (newValue, oldValue) {
        window.localStorage.setItem('step', newValue);
        this.setOrCreateOnlineFitting();
      },
      underbust_size: function (newValue, oldValue) {
        window.localStorage.setItem('underbust_size', newValue);
      },
      cup_size: function (newValue, oldValue) {
        window.localStorage.setItem('cup_size', newValue);
      },
      shape: function (newValue, oldValue) {
        window.localStorage.setItem('shape', newValue);
      },
      type: function (newValue, oldValue) {
        if(newValue){
          window.localStorage.setItem('type', newValue);
        } else {
          window.localStorage.removeItem('type');
        }
        if (this.online_fitting_id) {
          this.fetchShopifyProducts();
        }
      },
      fit: function (newValue, oldValue) {
        window.localStorage.setItem('fit', newValue);
        if (this.online_fitting_id) {
          this.fetchShopifyProducts();
        }
      },
      waist_size: function() {
        window.localStorage.setItem('waist_size', this.waist_size);
        if (this.waist_size) {
          this.skipped_bottoms = false;
        }
        this.setOrCreateOnlineFitting();
      },
      hip_size: function() {
        window.localStorage.setItem('hip_size', this.hip_size);
        if (this.hip_size) {
          this.skipped_bottoms = false;
        }
        this.setOrCreateOnlineFitting();
      },
      skipped_bottoms: function() {
        window.localStorage.setItem('skipped_bottoms', this.skipped_bottoms);
        this.setOrCreateOnlineFitting();
      },
      online_fitting_id: function() {
        window.localStorage.setItem('online_fitting_id', this.online_fitting_id);
        if (this.online_fitting_id) {
          this.fetchOnlineFitting();
          this.fetchShopifyProducts();
        }
      },
      use_centimeters: function() {
        window.localStorage.setItem('use_centimeters', this.use_centimeters);
      },
      category() {
        this.step = 1;

        if (this.category !== '') {
          this.type = this.types[this.division_types[this.category][0]];
        }
        
        window.localStorage.setItem('category', this.category);
      },
      age() {
        window.localStorage.setItem('age', this.age);
      },
      weight() {
        window.localStorage.setItem('weight', this.weight);
      },
      height() {
        window.localStorage.setItem('height', this.height);
      },
    },
    computed: {
      type_label(){
        return getKeyByValue(this.types, this.type);
      },
      uk_size(){
        return this.new_uk_measurements(this.shape, this.underbust_size, this.cup_size, this.fit);
      },
      looser_size(){
        return this.new_uk_measurements(this.shape, this.underbust_size, this.cup_size, 'loose');
      },
      normal_size(){
        return this.new_uk_measurements(this.shape, this.underbust_size, this.cup_size, 'normal');
      },
      tighter_size(){
        return this.new_uk_measurements(this.shape, this.underbust_size, this.cup_size, 'tight');
      },
      isBottomType() {
        return this.type !== 'Tops';
      },
      is_male() {
        return ['men', 'mini_men', 'youth_men', 'baby_boy'].includes(this.category);
      },
      is_mini_or_baby() {
        return ['mini_men', 'mini_lady', 'baby_boy', 'baby_girl'].includes(this.category);
      },
    },
    created() {
      this.setOrCreateOnlineFitting();
    },
    methods:{
      reset(){
        this.step = 1;
        this.underbust_size = null;
        this.cup_size = null;
        this.shape = null;
        this.type = null;
        this.fit = 'normal';
      },
      get_alternate_size(size, index_change) {
        let cur_ind = this.sizes.findIndex((s) => s === size);
        if (cur_ind < 0) {
          return '';
        }

        cur_ind += index_change;
        
        if (cur_ind >= this.sizes.length) {
          return this.sizes[this.sizes.length - 1];
        } else {
          return this.sizes[cur_ind];
        }
      },
      async setOrCreateOnlineFitting() {
        let band_size = this.underbust_size;
        let cup_size = this.cup_size;
        let waist_size = this.waist_size;
        let hip_size = this.hip_size;
        if (this.use_centimeters) {
          band_size = Math.round((band_size / 2.54) * 2) / 2;
          cup_size = Math.round((cup_size / 2.54) * 2) / 2;
          waist_size = Math.round((waist_size / 2.54) * 2) / 2;
          hip_size = Math.round((hip_size / 2.54) * 2) / 2;
        }

        const body = {
          band_size,
          cup_size,
          shape: this.shape,
          waist_size,
          hip_size,
          weight: this.weight,
        };

        if (this.waist_size === '' || this.hip_size === '') {
          body.waist_size = null;
          body.hip_size = null;
        }

        if (!this.shape) {
          delete body.shape;
        }

        if (this.weight === '') {
          body.weight = null;
        }

        if (this.online_fitting_id) {
          const response = await fetch(`${host}/api/fittings/online_fitting/?online_fitting_id=${this.online_fitting_id}`, {
            method: 'PUT',
            headers: {
              'X-CSRFToken': window.csrfmiddlewaretoken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });

          if (response.status === 200) {
            const json = await response.json(); 
            this.online_fitting_id = json.id;
            this.online_fitting = json;
            await this.fetchShopifyProducts();
          } else {
            this.online_fitting_id = null;
            this.setOrCreateOnlineFitting();
          }
        } else {
          const response = await fetch(`${host}/api/fittings/online_fitting/`, {
            method: 'POST',
            headers: {
              'X-CSRFToken': window.csrfmiddlewaretoken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });

          if (response.status === 201) {
            const json = await response.json(); 
            this.online_fitting_id = json.id;
            this.online_fitting = json;
            await this.fetchShopifyProducts();
          } else {
            // add error here
          }
        }
      },
      async fetchShopifyProducts() {
        if (!this.type) {
          return;
        }

        this.fittings = null;

        const response = await fetch(`${host}/api/fittings/fitting_cadre/?online_fitting_id=${this.online_fitting_id}&product_type=${this.type}&division=${this.categories[this.category]}&fit=${this.fit}`, {
          method: 'GET',
          headers: {
            'Cache-Control': 'no-store',
          },
        });

        if (response.status === 200) {
          const json = await response.json();
          this.fittings = json.products;
        } else {
          // add error here
        }
      },
      async fetchOnlineFitting() {
        const response = await fetch(`${host}/api/fittings/online_fitting/?online_fitting_id=${this.online_fitting_id}`, {
          method: 'GET',
          headers: {
            'Cache-Control': 'no-store',
          },
        });

        if (response.status === 200) {
          const json = await response.json();
          this.online_fitting = json;
        } else {
          this.setOrCreateOnlineFitting();
        }
      },
      shapeToDisplayName(shape) {
        if (shape === 'Standard') {
          return 'Round';
        } else if (shape === 'Swooping') {
          return 'Swooping';
        } else if (shape === 'Sagging') {
          return 'Relaxed';
        } else if (shape === 'Large') {
          return 'Large';
        } else if (shape === 'Small') {
          return 'Small';
        } else if (shape === 'Tubular') {
          return 'Conical';
        } else if (shape === 'Pigeon') {
          return 'Flattened';
        }
      },
    },
  }
</script>

<style lang="less">
.laya-swim-fitting {
  @primary-color: #1c1b1b;
  @background-color-1: #dbccbc;
  @background-color-2: #fff;
  @color-1: rgb(24, 31, 51);
  @color-2: rgb(106, 106, 106);
  @color-3: rgb(255, 255, 255);
  @font-size-1: 16px;
  @font-size-2: 22px;
  @font-size-3: 13px;
  @font-size-4: 14px;
  @font-weight-1: 400;
  @spacing-1: 13px;
  @spacing-2: 26px;

  * {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
    line-height: 1.65;
    font-size: @font-size-1 !important;
    color: @primary-color;
  }

  h1, h2, h3, h4, h5 {
    font-size: @font-size-2 !important;
    margin: @spacing-1 0 !important;
    letter-spacing: .15em;
    text-transform: uppercase;
    text-align: left;
  }

  h4 {
    font-size: 18px !important;
  }

  .product img {
    margin: 0 !important;
  }

  h2.clickable {
    background-color: @background-color-1 !important;
    text-align: center;
    padding: @spacing-1 0;
    margin: 0 0 4px !important;
  }

  h2.clickable:hover {
    background-color: #f1e3d4 !important;
  }

  img + .container {
    margin-top: @spacing-2;
  }

  p {
    margin: 0 0 @spacing-2;
  }

  a {
    font-weight: 700;
  }

  .btn {
    font-size: @font-size-4 !important;
    color: @color-3 !important;
    line-height: 1.44 !important;
    letter-spacing: 2px !important;
    text-transform: uppercase !important;
    width: 100% !important;
    border: solid 1px @primary-color !important;
    background-color: @primary-color !important;
    padding: 14px 28px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400 !important;
  }

  .btn:hover, .btn.selected {
    background-color: @color-3 !important;
    color: @color-1 !important;
  }

  .text-center {
    text-align: center;
  }

  .form-control {
    display: block;
    -webkit-appearance: none;
    padding: 12px 14px !important;
    border-radius: 0;
    border: 1px solid #dcdde0;
    width: 100%;
    transition: border-color .1s ease-in-out;
    background: 0 0;
    outline: 0;
  }
  .form-control:focus, .form-control:active {
    outline: 0;
    border-color: @primary-color;
  }

  .step-label {
    background-color: @primary-color !important;
  }

  form.slider {
    text-align: center;
  }

  .container {
    max-width: 400px;
    margin: 0 auto;
    padding: 0px !important;

    p {
      text-align: left;
    }

    .form-control {
      padding: 12px;
    }

    input {
      box-sizing: border-box;
      width: 100%;
      outline-color: black;
      font-size: 14px;
    }

    button {
      width: 100%;
      border: none;
      background-color: black;
      padding: 12px 0;
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      font-weight: bold;
    }

    a {
      background-color: white !important;
      color: black;
    }
  }
  .fitting > .form-group {
    margin-top: 15px;
    margin-bottom: 0px;
  }
  img {
    max-width: 100%;
    margin: 0 auto !important;
  }
  .center {
    text-align: center;
  }
  .clickable, button {
    cursor: pointer;
  }
  .form-group {
    margin-bottom: 15px;
  }
  .form-control {
    width: 300px;
    padding: 15px;
  }
  .btn.selected {
    color: white;
    background-color: gray;
  }
  .btn-primary {
    padding: 15px;
    background-color: #fa1f97;
    color: white;
  }
  .btn-danger {
    padding: 10px;
    color: white;
    background-color: red;
  }
  .btn-next {
    padding: 15px 90px;
  }
  .btn-skip {
    background-color: #0187cf;
  }
  .btn-restart {
    background-color: #00bfd4;
  }
  .btn-skip-step {
    background-color: transparent;
    color: black;
    border: none;

    &:hover {
      text-decoration: underline;
    }
  }
  .step-label {
    display: inline-block;
    width: 100px;
    background-color: black;
    color: white;
    font-size: 25px;
    margin-bottom: 12px;
  }
  form.slider {
    border-top: #e8e9eb solid 1px;
  }
  h2, h3 {
    font-size: 24px;
    font-weight: normal;
  }
  h3 {
    margin-top: 0;
  }
  h2.clickable {
    font-size: 18px;
    background-color: lightgrey;

    span {
      display: block;
    }

    .step {
      text-transform: uppercase;
      font-weight: bold;
      color: black;
    }
  }
  .selected {
    border: black 1px solid;
  }
  .ff-logo {
    img {
      margin-left: 10px !important;
    }
  }

  .pre-step {
    margin-bottom: 20px;

    h2 {
      margin: 40px 0 !important;
    }
  }

  .categories {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px;

    .btn {
      background-color: white !important;
      color: @primary-color !important;
      padding: 14px 5px !important;

      &:hover {
        background-color: @color-1 !important;
        color: white !important;
      }

      &.selected {
        background-color: @color-1 !important;
        color: white !important;
      }
    }
  }
}
</style>
